import { FC, useEffect } from 'react';
import { useAtomValue } from 'jotai';
import { PinterestScript, PinterestNoScript } from '~/components/pinterest';
import { $EnablePinterest } from 'shared/atoms';

export const PinterestHead: FC = () => {
  const enable = useAtomValue($EnablePinterest);

  if (enable) {
    return <PinterestScript />;
  }
};

export const PinterestBody: FC = () => {
  const enable = useAtomValue($EnablePinterest);

  useEffect(() => {
    if (enable && 'pintrk' in window) {
      window.pintrk('track', 'pagevisit', {
        event_id: 'eventId0001',
      });
    }
  }, []);

  if (enable) {
    return <PinterestNoScript />;
  }
};
